export const buttonConfigGlobals = { }

export const commonConfigGlobals = { }

export const configGlobals = { }
